import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Truck } from "@phosphor-icons/react";
import client from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const { data } = await client.post(
          "/auth/session",
          {},
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          }
        );
        setUser(data.user);
        // Clear the hash and redirect
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Signed in with Google");
        nav("/app/dashboard", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 rounded-md bg-[#FF5A1F] flex items-center justify-center">
          <Truck size={26} weight="bold" color="#0A0A0A" />
        </div>
        <div className="text-neutral-400 text-sm">Signing you in with Google...</div>
        <div className="w-24 h-0.5 bg-white/10 overflow-hidden rounded-full">
          <div className="h-full bg-[#FF5A1F] animate-pulse w-1/2" />
        </div>
      </div>
    </div>
  );
}
